export function normalizeDataForApi(data: object) {
  const parsedObject = {}
  const keys = Object.keys(data)
  for (let i = 0, l = keys.length; i < l; i++) {
    const key = keys[i]
    parsedObject[key] = data[key] === null || data[key] === undefined || data[key] === '' ? null : data[key]
  }
  return parsedObject
}

export enum TemporalEntityId {
  unset = -999,
  delete = -99,
  new = -9,
}
